<script setup lang="ts">
interface Props {
  text: string
  tagline?: string | null
  type?: 'title' | 'subtitle'
  iconClass?: string | null
  noWrap?: boolean
  padding?: 'large' | 'small'
}

const props = withDefaults(defineProps<Props>(), {
  type: 'title',
  padding: 'small',
  tagline: null,
  icon: null,
  iconClass: null,
})

const dinamicClasses = {
  'text-2xl md:text-3xl lg:text-4xl': props.type === 'title',
  'text-lg md:text-xl lg:text-2xl': props.type === 'subtitle',
  'flex items-center gap-2': !!props.iconClass,
  'py-5': props.padding === 'large',
  'py-1': props.padding === 'small',
}
</script>

<template>
  <div
    :class="dinamicClasses"
    class="leading-tight title-component"
  >
    <span
      v-if="iconClass"
      class="flex aspect-square items-center justify-center rounded-lg bg-primary/50 p-2 title-icon-container"
    >
      <span
        class="text-xl lg:text-2xl text-current tracking-tighter"
        :class="iconClass"
      />
    </span>
    <div
      class="title-text leading-none"
      :class="noWrap ? 'text-nowrap' : ''"
    >
      <span class="font-bold">
        {{ text }}
      </span>

      {{ tagline }}
    </div>
  </div>
</template>
